import { TextField } from '@mui/material';
import { PlatformEntity } from '@provision/entity-types';
import { Controller, useFormContext } from 'react-hook-form';
import { CustomAttributeGroup } from 'src/graphql/entities/custom-attributes';

export interface CustomAttributeGroupFormValues {
  editCustomAttributeGroup?: string;
}

export const CustomAttributeGroupForm = ({
  entity,
  onSubmit,
  index,
  partnerId,
}: {
  onSubmit: (value: string) => void;
  entity?: PlatformEntity;
  partnerId: number;
  index: number;
}) => {
  const formMethods =
    useFormContext<
      Record<string, Record<string, Partial<CustomAttributeGroup>[] | undefined>>
    >();
  const { control, formState } = formMethods;

  const errorMsg = formState.errors[entity?.id!]?.[partnerId]?.[index]?.displayName?.message;
  const hasErrorMsg = typeof errorMsg === 'string';

  return (
    <Controller
      name={`${entity?.id!}.${partnerId}.${index}.displayName`}
      control={control}
      rules={{
        required: true,
      }}
      render={({ field: props }) => (
        <TextField
          {...props}
          error={!!hasErrorMsg}
          variant="outlined"
          size="small"
          label="Group name"
          autoFocus
          required
          sx={{
            marginTop: 2,
          }}
          onKeyDown={(e) => {
            if (['Enter', 'Escape'].includes(e.key)) {
              e.stopPropagation();
              e.preventDefault();
              const value = (e.target as HTMLInputElement).value;
              onSubmit(value);
            }
          }}
          inputProps={{
            onBlur: ({ target }) => {
              const value = (target as HTMLInputElement).value;
              onSubmit(value);
            },
          }}
        />
      )}
    />
  );
};
